import { useContext, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/api";
import AppContext from "../../utils/AppContext";
import Cookies from 'js-cookie';
import i18next from "i18next";

export default function Logout() {
  const navigate = useNavigate();
  const [, dispatch] = useContext(AppContext);
  const queryClient = useQueryClient();

  const queryFn = () => {
    const params = new URLSearchParams();
    params.append('client_id', process.env.REACT_APP_API_CLIENT_ID);
    params.append('token', Cookies.get('pl__api_refresh_token'));
    params.append('token_type_hint', 'refresh_token');
    
    return api.post('/auth/revoke_token/', params);
  }

  const { status } = useQuery({ queryKey: ['logout'], queryFn });

  useEffect(() => {
    // force deletion of cookies even if the status fails
    if (status !== 'loading') {
      dispatch({ type: 'currentUser/delete' });
      queryClient.invalidateQueries();
      queryClient.removeQueries();

      if (i18next.language === 'en') {
        navigate('/login');
      }
      else {
        navigate(`/${i18next.language}/login`);
      }
    }
  }, [status, dispatch, navigate, queryClient]);

  if (status === 'loading') {
    return <div>Logging out...</div>
  }
}
